exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3YG7I {\n  color: #A0A0A0;\n  font-size: 14px;\n  padding: 15px 0;\n  border: 0;\n}\n._3YG7I:hover,\n._3YG7I:focus,\n._3YG7I:active,\n._3YG7I._33eJS {\n  background-color: #fff;\n  color: #88733C;\n}\n._3YG7I ._3ecW2 {\n  margin-top: 8px;\n  text-transform: capitalize;\n  font-family: 'Open Sans';\n}\n", ""]);

// Exports
exports.locals = {
	"button": "_3YG7I",
	"active": "_33eJS",
	"label": "_3ecW2"
};